module.exports = __webpack_public_path__ + "static/assets/41492c4650fd2cc8eb4762eddf9288f0.png";